var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1257 16.7716C5.59304 17.6842 1.57448 19.5476 4.02205 21.8795C5.21767 23.0185 6.54928 23.8332 8.22345 23.8332H17.7765C19.4507 23.8332 20.7823 23.0185 21.9779 21.8795C24.4255 19.5476 20.407 17.6842 18.8743 16.7716C15.2802 14.6315 10.7198 14.6315 7.1257 16.7716Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 7.0415C17.875 9.73389 15.6924 11.9165 13 11.9165C10.3076 11.9165 8.125 9.73389 8.125 7.0415C8.125 4.34912 10.3076 2.1665 13 2.1665C15.6924 2.1665 17.875 4.34912 17.875 7.0415Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a223ffd18d74486be591d361a21f4dee.svg";
export { ForwardRef as ReactComponent };